import { render, staticRenderFns } from "./AppHeaderNotice.vue?vue&type=template&id=342130ce"
import script from "./AppHeaderNotice.vue?vue&type=script&lang=js"
export * from "./AppHeaderNotice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports